<template>
    <div
        class="PageBuilderPlaceholder"
    >
        <div
            class="grid grid--xlarge"
        >
            <div class="grid__item lap-and-up-one-third">
            </div>
            <div class="grid__item lap-and-up-two-thirds">
                <div class="PageBuilderPlaceholder__slot">
                    <slot>
                        <BaseButton
                            :href="url"
                        >
                            {{  text  }}
                        </BaseButton>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PageBuilderPlaceholder',
    props: {
        url: {
            type: String,
        },
        text: {
            type: String,
        }
    }
}
</script>
<style lang="scss" scoped>
    .PageBuilderPlaceholder__slot > ::v-deep * {
        @include media-query(lap) {
            margin-left: 3.5rem;
        }
        @include media-query(desk) {
            margin-left: 5.25rem;
        }
    }
</style>
